module.exports = __webpack_public_path__ + "static/media/commerical-5.65af5a27.jpg";